import * as actionIndex from "./actions";
import * as typeIndex from "./types";

export const types = typeIndex;
export const actions = actionIndex;
